module.exports = __webpack_public_path__ + "img/carousel-2.cd081887.png";